import React from 'react';
import { Link } from 'react-location';

import './Footer.scss';

export const Footer = () => (
  <footer className="footer">
    <div className="footer-wrapper">
      <img className="footer-logo" src="/images/footer-logo.svg" alt="Logo" />

      <nav className="footer-column">
        <Link className="footer-link" to="/#projets">Projets</Link>
        <Link className="footer-link" to="/a-propos">À propos</Link>
        <Link className="footer-link" to="/a-propos#contact">Contact</Link>
      </nav>

      <nav className="footer-column">
        <a className="footer-link" href="https://www.linkedin.com/in/leapicault/" target='_blank' rel="noreferrer">Linkedin</a>
        <a className="footer-link" href="https://www.behance.net/leapicault" target='_blank' rel="noreferrer">Behance</a>
      </nav>

      <div className="footer-column">
        <p>© {new Date().getFullYear()} Léa Picault</p>
        <p>All rights reserved</p>
        Mentions légales
      </div>
    </div>
  </footer>
);

export default Footer;